// API Routes Constants
export const API_ROUTES = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    GENERATE_OTP: (email: string) => `/auth/generate-otp?email=${encodeURIComponent(email)}`,
    VERIFY_OTP: (email: string, otp: string) =>
      `/auth/verify-otp?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`,
    UPDATE_PASSWORD: '/auth/update-password',
    SET_PASSWORD: '/auth/set-password',
  },
  ACCOUNTS: {
    LIST: '/accounts',
    DETAILS: (id: string) => `/accounts/${id}`,
    CREATE: '/accounts',
    UPDATE: (id: string) => `/accounts/${id}`,
    DELETE: (id: string) => `/accounts/${id}`,
  },
  TRANSACTIONS: {
    LIST: '/transactions',
    DETAILS: (id: string) => `/transactions/${id}`,
    CREATE: '/transactions',
    APPROVE: (id: string) => `/transactions/${id}/approve`,
    REJECT: (id: string) => `/transactions/${id}/reject`,
  },
  CUSTOMERS: {
    LIST: '/customers',
    DETAILS: (id: string) => `/customers/${id}`,
    CREATE: '/customers',
    UPDATE: (id: string) => `/customers/${id}`,
  },
  BLOCKLIST: {
    LIST: '/blacklist',
    DETAILS: (id: string) => `/blacklist/${id}`,
    CREATE: '/blacklist',
    UPDATE: (id: string) => `/blacklist/${id}`,
    DELETE: (id: string) => `/blacklist/${id}`,
    CATEGORIES: '/blacklist/categories',
  },
} as const;
